import { scale } from '@utils/normalize';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  contentContainerStyle: { flexGrow: 1, paddingHorizontal: scale(12) },
});

export default styles;
